
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';
import { FcmService } from '../../service/fcm.service';

@Component({
  selector: 'app-add-upcoming-release',
  templateUrl: './add-upcoming-release.component.html',
  styleUrls: ['./add-upcoming-release.component.css']
})
export class AddUpcomingReleaseComponent implements OnInit {

  UpComingReleaseForm: FormGroup;
  cover_image: File;
  cover_image_url: any;
  loading: boolean = false;
  load: boolean = false;
  coverimageerror: any = false;
  id: string="";
  SingleData: any;
  coverimageerror_1: boolean=false;
  cover_image_1: any;
  cover_image_url_1: any;

  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef,
  private fcmSr:FcmService) {
    this.toastr.setRootViewContainerRef(vcr);
    }

  ngOnInit() {
    this.initForm();
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id') ? params.get('id') : "";
      if (this.id) {
        this.comicService.getsinglecomic(this.id, 'UpcomigReleases').then(data => {
          // const admindata = data.valueChanges();
          data.subscribe(SingleData => {
            const data = SingleData;
            this.SingleData = SingleData;
            console.log(data)
            this.UpComingReleaseForm.get('e_book_title').setValue(data['e_book_title']);
            this.UpComingReleaseForm.get('e_book_category').setValue(data['e_book_category']);
            this.UpComingReleaseForm.get("e_book_category").updateValueAndValidity();
            this.UpComingReleaseForm.get('e_book_about').setValue(data['e_book_about']);
            this.UpComingReleaseForm.get('e_book_author_name').setValue(data['e_book_author_name']);
            this.UpComingReleaseForm.get('e_book_numbers_chapters').setValue(data['e_book_numbers_chapters']);
            this.UpComingReleaseForm.get('e_book_about_author').setValue(data['e_book_about_author']);
            this.UpComingReleaseForm.get('e_book_sponser_url').setValue(data['e_book_sponser_url']);
            const date = new Date(data['e_book_release_date'].seconds*1000);
            this.UpComingReleaseForm.get('e_book_release_date').setValue(date);
            this.UpComingReleaseForm.get('cover_image').setValue(data['cover_image']);
            this.cover_image_url = data['cover_image'];
            this.UpComingReleaseForm.get('sponsor_image').setValue(data['sponsor_image']);
            this.cover_image_url_1 = data['sponsor_image'];
    
          });
        });
      }
    });
  }
  initForm(){
    this.UpComingReleaseForm = this.form.group({
      e_book_title: ['', [Validators.required]],
      e_book_category: ['', [Validators.required]],
      e_book_about:['',[Validators.required]],
      e_book_author_name: ['', [Validators.required]],
      e_book_about_author: ['', [Validators.required]],
      e_book_numbers_chapters: ['', [Validators.required]],
      e_book_release_date: ['', [Validators.required]],
      e_book_sponser_url: ['', [Validators.required]],
      cover_image: ['', []],
      sponsor_image:['',[]]
    });
  }
  changeListner2(event) {
    this.coverimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  changeListner_1(event) {
    this.coverimageerror_1 = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image_1 = event.target.files[0];
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.cover_image_url_1 = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  async AddUpcomingRelease(value, valid) {
    if (valid) {
      this.loading = true;
      if (this.id) {
        let coverimage;
        let sponserImg;
        // Checking if the cover image is changed if changed the update the image in sapces and also db.
        if (this.cover_image) {
          coverimage = await this.auth.uploadimage('upcoming/cover/', this.cover_image, false);
          this.UpComingReleaseForm.get('cover_image').setValue(coverimage['Location']);
        }
        if (this.cover_image_1) {
          sponserImg = await this.auth.uploadimage('upcoming/cover/', this.cover_image_1, false);
          this.UpComingReleaseForm.get('sponsor_image').setValue(sponserImg['Location']);
        }
        let data = this.UpComingReleaseForm.value;
        data.e_book_release_date = new Date(this.UpComingReleaseForm.value.e_book_release_date);
        data.e_book_release  = new Date(this.UpComingReleaseForm.value.e_book_release_date).toString();
        const document = await this.afs.doc(`/UpcomigReleases/${this.id}`);
        const update = await document.update(data);
        await this.toastr.success('Upcoming release updated successfully!', 'Success!');
        setTimeout(() => {
          this.router.navigate(['/upcoming-releases']);
        }, 2000);
        this.loading = false;
        return;
      }
      if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
      if (!this.cover_image_1) { this.coverimageerror_1 = true; this.loading = false; return false; }
      const coverimage = await this.auth.uploadimage('upcoming/cover/', this.cover_image, false);
      const sponser_image = await this.auth.uploadimage('upcoming/cover/', this.cover_image_1, false);
      var CoverImg  = coverimage['Location'];
      var Sponser_Img  = sponser_image['Location'];
      this.UpComingReleaseForm.get('cover_image').setValue(CoverImg);
      this.UpComingReleaseForm.get('sponsor_image').setValue(Sponser_Img);
      let data = this.UpComingReleaseForm.value;
      data.e_book_release_date = new Date(this.UpComingReleaseForm.value.e_book_release_date);
      data.e_book_release  = new Date(this.UpComingReleaseForm.value.e_book_release_date).toString();
      data.createdAt = new Date(),
      data.date = new Date().toString(),
      console.log(data);
      const UpcomingAdd = await this.afs.collection('UpcomigReleases').add(data);
      const UpcomingAddId = UpcomingAdd.id;
      const id = await this.afs.doc(`/UpcomigReleases/${UpcomingAddId}`).update({ id: UpcomingAddId });
      this.toastr.success('Upcoming Release Addes successfully!', 'Success!');
      let FCMdata = {
        "to":`/topics/all`,
        "notification": {
            "title": `Webnnel Added a New Upcoming Release`,
            "body": data.e_book_title,
            "sound": "default",
        },
         data: {
            "title": `Webnnel Added a New Upcoming Release`,
            "body": data.e_book_title,
            "sound": "default",
            "appUrl":"/tabs/upcoming-release",
            "id":UpcomingAddId,
            "type":"UpcomingReleases",
        },
    };
    this.fcmSr.postDataWithToken(FCMdata).subscribe((response)=>{
      setTimeout(() => {
        this.router.navigate(["/upcoming-releases"]);
      }, 2000);
    },error=>{
      setTimeout(() => {
        this.router.navigate(["/upcoming-releases"]);
      }, 2000);
    })
    this.loading = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/upcoming-releases/add-upcoming-release/add-upcoming-release.component.ts